// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2lrdr","inner":"Form_inner__3Wx6N","range":"Form_range__4xC-i","name":"Form_name__25lYb","actions":"Form_actions__MQHfb"};